// ======================================================================
// FILE:
// src/modules/expense_management/claims/services/expenseMasterService.js
//
// MODULE:
// Expense Management
//
// FEATURE:
// Expense Master Service
// ======================================================================

import axiosClient from "../../../../api/axiosClient";

const BASE_URL =
    "/api/expense-management/masters";

const expenseMasterService = {

    // ============================================================
    // EXPENSE POLICIES
    // ============================================================

    async listExpensePolicies(params = {}) {

        const { data } =
            await axiosClient.get(

                `${BASE_URL}/expense-policies`,

                {
                    params,
                }

            );

        return data.data.data;

    },

    // ============================================================
    // WORKFLOW TYPES
    // ============================================================

    async listWorkflowTypes() {

        const { data } =
            await axiosClient.get(

                `${BASE_URL}/workflow-types`

            );

        return data.data;

    },

    // ============================================================
    // DEPARTMENTS
    // ============================================================

    async listDepartments() {

        const { data } =
            await axiosClient.get(

                `${BASE_URL}/departments`

            );

        return data.data;

    },

    // ============================================================
    // APPROVAL LEVELS
    // ============================================================

    async listApprovalLevels() {

        const { data } =
            await axiosClient.get(

                `${BASE_URL}/approval-levels`

            );

        return data.data.data;

    },

    // ============================================================
    // REJECT ACTIONS
    // ============================================================

    async listRejectActions() {

        const { data } =
            await axiosClient.get(

                `${BASE_URL}/reject-actions`

            );

        return data.data;

    },
    // ============================================================
// EXPENSE CATEGORIES
// ============================================================

async listExpenseCategories(params = {}) {

    const { data } =
        await axiosClient.get(

            `${BASE_URL}/expense-categories`,

            {
                params,
            }

        );

    return data.data.data;

},

// ============================================================
// EXPENSE TYPES
// ============================================================

async listExpenseTypes(params = {}) {

    const { data } =
        await axiosClient.get(

            `${BASE_URL}/expense-types`,

            {
                params,
            }

        );

    return data.data.data;

},

// ============================================================
// CURRENCIES
// ============================================================

async listCurrencies(params = {}) {

    const { data } =
        await axiosClient.get(

            `${BASE_URL}/currencies`,

            {
                params,
            }

        );

    return data.data.data;

},

};

export default expenseMasterService;

